import { ReactNode } from 'react';

interface OnboardingStepProps {
  title: string;
  subtitle?: string;
  onNext: () => void;
  onBack?: () => void;
  nextLabel?: string;
  backLabel?: string;
  isNextDisabled?: boolean;
  children: ReactNode;
}

export function OnboardingStep({
  title,
  subtitle,
  onNext,
  onBack,
  nextLabel = 'Next',
  backLabel = 'Back',
  isNextDisabled = false,
  children
}: OnboardingStepProps) {
  return (
    <div className="flex flex-col h-full max-w-2xl mx-auto py-8 px-4">
      <div className="mb-8 text-center">
        <h2 className="text-3xl font-black text-white mb-2 tracking-tight">{title}</h2>
        {subtitle && <p className="text-[var(--t-text-muted)] text-sm">{subtitle}</p>}
      </div>

      <div className="flex-1 mb-8">
        {children}
      </div>

      <div className="flex justify-between items-center gap-4 pt-6 border-t border-[var(--t-border)]">
        {onBack ? (
          <button
            onClick={onBack}
            className="px-6 py-3 rounded-xl border border-[var(--t-border)] text-sm font-semibold text-[var(--t-text-muted)] hover:text-white hover:bg-[var(--t-surface-hover)] transition-all"
          >
            {backLabel}
          </button>
        ) : (
          <div />
        )}
        <button
          onClick={onNext}
          disabled={isNextDisabled}
          className="px-8 py-3 rounded-xl text-sm font-bold text-white bg-[var(--t-primary)] hover:bg-[var(--t-primary-hover)] transition-all disabled:opacity-50"
        >
          {nextLabel}
        </button>
      </div>
    </div>
  );
}
